import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';
import { CustomerService } from '../../../core/services/customer.service';
import { SendContactEmailRequest } from '../../models/send-contact-email-request';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-contact',
    imports: [
    ReactiveFormsModule,
    TranslateModule,
    AnimateOnScrollDirective,
    ToastModule
],
    providers: [MessageService],
    templateUrl: './contact.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  contactForm: FormGroup;
  isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private customerService: CustomerService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: [''],
      subject: ['', Validators.required],
      message: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.contactForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      
      const request: SendContactEmailRequest = {
        name: this.contactForm.value.name,
        email: this.contactForm.value.email,
        phone: this.contactForm.value.phone || undefined,
        subject: this.contactForm.value.subject,
        message: this.contactForm.value.message
      };

      this.customerService.sendEmail(request).subscribe({
        next: (success) => {
          if (success) {
            this.translate.get(['contact.form.SUCCESS_MESSAGE', 'common.success']).subscribe(translations => {
              this.messageService.add({
                severity: 'success',
                summary: translations['common.success'],
                detail: translations['contact.form.SUCCESS_MESSAGE'],
                life: 5000
              });
            });
            this.contactForm.reset();
          }
          this.isSubmitting = false;
        },
        error: () => {
          this.translate.get(['contact.form.ERROR_MESSAGE', 'common.error']).subscribe(translations => {
            this.messageService.add({
              severity: 'error',
              summary: translations['common.error'],
              detail: translations['contact.form.ERROR_MESSAGE'],
              life: 5000
            });
          });
          this.isSubmitting = false;
        }
      });
    }
  }
}